import { ReactNode } from 'react';
import { BreadcrumbProps as BSBreadcrumbProps } from 'react-bootstrap';
import { BreadcrumbStyled } from './Breadcrumb.styles';

interface BreadcrumbProps extends Omit<BSBreadcrumbProps, 'as' | 'children'> {
  children?: ReactNode;
}

const Breadcrumb = ({ children, ...props }: BreadcrumbProps) => {
  return <BreadcrumbStyled {...props}>{children}</BreadcrumbStyled>;
};

Breadcrumb.defaultProps = {
  children: undefined,
};

export default Breadcrumb;
